// This function allow to reference async chunks and sibling chunks for the entrypoint
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 6723) return "static/chunks/worker-chunks-e11b0a1ef0bcebbe.js";
	if (chunkId === 8940) return "static/chunks/8940-2680582ce3921897.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"2766":"824cb480f00cec61","6776":"0440f85945ba4278"}[chunkId] + ".js";
};